<template>
   <div class="gallery  p-0">
      <!-- container-fluid -->
      <div v-if="shortdesc" class="row">
         <div class="col">
            <p class="text-center mb-1 shortdesc">{{ shortdesc }}</p>
         </div>
      </div>
      <div class="row">
         <div class="col-12">
            <div v-if="isClient" class="card-selector">
               <mq-layout
                  class="card-selector-wrapper"
                  :mq="['xs', 'sm', 'md', 'navigation', 'lg']"
               >
                  <BaseModalSelect
                     v-model="selectedGalleryOption"
                     class="gallery-selector"
                     :options="galleryOptions"
                     placeholder="Choose a Product"
                  />
               </mq-layout>
               <mq-layout class="card-selector-wrapper" mq="xl+">
                  <ul id="myTab" class="nav nav-pills grouped">
                     <li v-for="(item, index) in gallery" :key="index" class="nav-item">
                        <a
                           :class="['nav-link bold', { active: isTabSelected(item) }]"
                           :href="getLink(item)"
                           @click.prevent="tabClickListener(item, index)"
                        >
                           {{ item.title }}
                        </a>
                     </li>
                  </ul>
               </mq-layout>
            </div>

            <div class="description-container  mt-3 pr-0 pr-xl-4">
               {{ selectedGallery.description }}
            </div>

            <div :class="['card-deck', 'card-deck-special', { 'show-animation': isTabChanged }]">
               <div
                  v-for="(cardItem, ii) in selectedGallery.items"
                  v-if="galleryType === ''"
                  :key="ii"
                  class="card"
               >
                  <a
                     :href="cardItem.onclick"
                     class="card-content"
                     @click.prevent="goto(cardItem.onclick)"
                  >
                     <div class="item-container">
                        <img
                           :src="cardItem.image || 'https://via.placeholder.com/350x150'"
                           alt="Card image cap"
                           class="card-img-top p-2"
                           style="padding-bottom: 0 !important"
                        />
                        <div class="card-body pb-2" style="padding-top: 15px">
                           <h2 class="card-title bold">{{ cardItem.title }}</h2>
                           <p class="card-text">{{ cardItem.subtitle }}</p>
                        </div>
                     </div>
                  </a>
               </div>

               <div v-if="selectedGallery.slug === 'fusionmaps'" class="card">
                  <div class="card-content explore-maps-content">
                     <div class="card-body d-flex align-items-center explore-maps">
                        <div class="text-center">
                           <h2 class="card-title bold mb-1">Explore our 1400+ Maps</h2>
                           <router-link to="/fusionmaps" class="btn btn-primary-grad">
                              Explore
                           </router-link>
                        </div>
                     </div>
                  </div>
               </div>

               <div
                  v-for="(cardItem, ii) in selectedGallery.items"
                  v-if="galleryType === 'slick'"
                  :key="ii"
                  class="card slick"
               >
                  <div
                     class="card-header"
                     :class="{
                        react: cardItem.title === 'React Component',
                        java: cardItem.title === 'Java Plugin',
                     }"
                  >
                     <a
                    v-if="cardItem.title != 'Blazor'"
                        :href="cardItem.onclick"
                        class="card-anchor card-content"
                        @click.prevent="goto(cardItem.onclick)"
                     >
                        <div class="card-heading-wrapper align-self-center">
                           <div class="img-container align-self-center ">
                              <img loading="lazy" :src="cardItem.image" alt="" />
                           </div>
                           <div class="card-title align-self-center mb-0">
                              <h2 v-if="cardItem.title">{{ cardItem.title }}</h2>
                              <p v-if="cardItem.subtitle" class="text-muted small">
                                 {{ cardItem.subtitle }}
                              </p>
                           </div>
                        </div>
                     </a>
                      <a
                    v-else
                        :href="cardItem.onclick"
                        class="card-anchor card-content"
                        @click.prevent="gotodev(cardItem.onclick)"
                     >
                        <div class="card-heading-wrapper align-self-center">
                           <div class="img-container align-self-center ">
                              <img loading="lazy" :src="cardItem.image" alt="" />
                           </div>
                           <div class="card-title align-self-center mb-0">
                              <h2 v-if="cardItem.title">{{ cardItem.title }}</h2>
                              <p v-if="cardItem.subtitle" class="text-muted small">
                                 {{ cardItem.subtitle }}
                              </p>
                           </div>
                        </div>
                     </a>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>

export default {
   name: 'Gallery',

   components: {
      BaseModalSelect: () => import('../core/BaseModalSelect'),
   },

   props: {
      gallery: {
         type: Array,
         default: () => [],
      },
      galleryType: {
         type: String,
         default: '',
      },
      shortdesc: {
         type: String,
         default: null,
      },
   },

   data: () => ({
      isClient: false,
      queryParamName: '',
      selectedGallery: null,
      selectedGalleryOption: '',
      isTabChanged: false,
   }),

   computed: {
      galleryOptions() {
         return this.gallery.map(item => ({
            text: item.title,
            value: item.slug,
         }));
      },
   },

   watch: {
      selectedGalleryOption(val) {
         this.selectGallery();

         this.$router
            .push({
               query: {
                  [this.queryParamName]: val,
               },
            })
            .catch(() => {});
      },

      $route() {
         if (this.$route.query[this.queryParamName]) {
            this.selectedGalleryOption = this.$route.query[this.queryParamName];
         } else {
            this.selectedGalleryOption = this.gallery[0].slug;
         }
      },
   },

   created() {
      this.queryParamName = 'product';
      if (this.$route.path.startsWith('/integrations')) {
         this.queryParamName = 'stack';
      }
      this.selectedGalleryOption = this.$route.query[this.queryParamName];

      if (!this.selectedGalleryOption) {
         this.selectedGalleryOption = this.gallery[0].slug;
      }

      this.selectGallery();
   },

   mounted() {
      this.isClient = true;
      this.animateTab();
   },

   methods: {
      isTabSelected(gallery) {
         return this.selectedGallery.slug === gallery.slug;
      },

      tabClickListener(gallery) {
         this.selectedGallery = gallery;
         this.selectedGalleryOption = gallery.slug;

         this.animateTab();
      },

      goto(link) {
         this.$router.push(link).catch(() => {});
      },
      gotodev(link) {
         window.location.href = link;
      },
      animateTab() {
         this.isTabChanged = true;
         setTimeout(() => {
            this.isTabChanged = false;
         }, 500);
      },

      getLink(item) {
         return `?${this.queryParamName}=${item.slug}`;
      },

      selectGallery() {
         this.gallery.some(item => {
            if (item.slug === this.selectedGalleryOption) {
               this.selectedGallery = item;
               return true;
            }
            return false;
         });
      },
   },
};
</script>

<style lang="scss" scoped>
@import '../../util';

.shortdesc {
   color: #73748c;
}

.grouped {
   display: inline-flex !important;
   border-radius: 4px;
   overflow: hidden;
   box-shadow: 0 2px 4px 0 rgba(62, 57, 107, 0.13);
   flex-wrap: nowrap;

   .nav-link {
      background: #ffffff;
      color: #686980;
      font-size: 16px;
      transition: all ease 0.4s;
      margin-right: 1px;

      &:hover {
         color: #6957da;
      }
   }
   .nav-link:last-child(1) {
      margin-right: 0;
   }
   .nav-link.active {
      box-shadow: none;
      background: #6957da;
      color: #ffffff;
   }
   .nac-item {
      padding: 13px 24px;
   }

   &.nav-pills {
      margin-bottom: 11px !important;
   }
}
.gallery {
   .gallery-selector {
      margin: 0 auto 15px auto;
      max-width: 300px;
      width: 100%;
   }

   .card-selector {
      margin-left: 0;
      margin-right: 0;

      // @include media-breakpoint-up(md) {
      //    margin-right: 25px;
      // }

      &-wrapper {
         display: flex;

         .nav {
            margin: 0 auto 15px auto;
         }
      }
   }

   .card {
      margin: 25px 25px 0 0;
      transition: all ease 0.35s;

      .card-anchor {
         text-decoration: none;
         img {
            width: 100%;
         }
      }
   }

   .slick {
      h2 {
         font-size: 16px;
         font-weight: 600;
         line-height: 20px;
         letter-spacing: 0.3px;
         // padding: 10px;
         padding-left: 0;
      }
   }
   .nav-link {
      border: none;
      border-radius: 0;
   }
   .card-header-tabs {
      justify-content: center;
   }
   .bg-primary {
      background: #6957da !important;
   }
   .card-body {
      h2 {
         margin-bottom: 1rem;
      }
   }

   .column-group {
      column-gap: 2.5rem;
   }

   .card-deck-special {
      margin: 15px -15px;

      .card {
         background: none;
         border-radius: 0;
         margin: 0;
         padding: 10px 15px 20px;
         flex: 0 0 auto;
         min-width: 100%;
         max-width: 100%;

         @media (min-width: 567px) {
            flex: 0 0 auto;
            min-width: 50%;
            max-width: 50%;
         }

         @media (min-width: 1200px) {
            flex: 0 0 auto;
            min-width: 33.33%;
            max-width: 33.33%;
         }

         .card-text {
            color: #686980;
            font-size: 16px;
            letter-spacing: 0.23px;
            line-height: 24px;
         }

         .card-title {
            font-size: 16px;
            letter-spacing: 0.23px;
            line-height: 20px;
            color: #212344;
         }

         .card-content {
            height: 100%;
            background: #fff;
            border-radius: 5px;
            box-shadow: 0 6px 14px 0 rgba(33, 35, 68, 0.05) !important;

            &.explore-maps-content {
               width: auto;
               transition: all 0.2s ease;
               text-decoration: none;
               &:hover {
                  transform: translateY(-4px);
                  transition: all 0.2s ease;
               }
            }
            .explore-maps {
               height: 100%;
               width: auto;
            }
         }

         a.card-content {
            transition: all 0.2s ease;
            text-decoration: none;
            &:hover {
               transform: translateY(-4px);
               transition: all 0.2s ease;
            }
         }

         .card-img-top {
            height: 200px;
         }

         &.slick {
            .card-header {
               padding: 0;
               height: 100%;
            }
            a {
               display: block;
               padding: 15px 15px 15px 5px;
               h2 {
                  margin: 0;
               }
            }
            .img-container {
               img {
                  height: 55px;
               }
            }
         }
      }
   }
}

.explore-maps {
   background-image: url('/public/images/small-map.svg');
   background-size: contain;
   background-repeat: no-repeat;
   background-position: center;
   .text-center {
      width: 100%;
   }
}
</style>
